import {Section} from "../grouping/Section";
import {SelectionList} from "../SelectionList";
import {ListItemButton} from "../ListItemButton";
import {Button, Col, Form, FormControl, FormGroup, FormLabel, FormSelect} from "react-bootstrap";
import {useFilecategorys} from "../../api/filecategoryapi";
import {useCallback, useState} from "react";
import {ModalPopUp} from "../grouping/ModalPopUp";
import {ModalContentContainer} from "../grouping/ModalContentContainer";
import {
    INSURANCE_BEHAVIOUR_EMPTY, useInsuranceBehaviourMutations, useInsurancesBehaviours
} from "../../api/insuranceandbehaviourapi";
import {useForm} from "../../utilities/formutilities";
import {FILE_EMPTY, useFileMutations} from "../../api/fileapi";
import {ButtonLoading} from "../ButtonLoading";

export function FileOption(props) {
    const {title} = props;
    const [open, setOpen] = useState(false);
    const [fileEditing, setFileEditing] = useState(undefined);
    const {insurancesBehaviours} = useInsurancesBehaviours();
    return <Section title={title}>
        <Col xs={12} className={"text-end"}>
            <Button onClick={() => setOpen(true)}>Nieuw</Button>
        </Col>
        <SelectionList>
            {insurancesBehaviours ? insurancesBehaviours.map(i => <ListItem key={i.id} onOpenChanged={setOpen}
                                                                            insuranceBehaviour={i}
                                                                            onFileEditingChanged={setFileEditing}></ListItem>) : ""}
        </SelectionList>
        <ModalPopUp open={open} onOpenChanged={setOpen} title={"Nieuw bestand link"}
                    modalContent={<FileOptionModalContent fileEditing={fileEditing} setFileEditing={setFileEditing}
                                                          onOpenChanged={setOpen}/>}/>

    </Section>
}

function ListItem(props) {
    const {insuranceBehaviour, onOpenChanged, icon, onFileEditingChanged} = props;

    return <ListItemButton onClick={() => {
        onFileEditingChanged(insuranceBehaviour);
        onOpenChanged(true);
    }}>
        <Col className={"text-start"}>
            {insuranceBehaviour ? insuranceBehaviour.title : "Geen Titel"}
        </Col>
        <Col xs={"auto"} className={"text-end"}>
            {icon}
        </Col>
    </ListItemButton>
}

function FileOptionModalContent(props) {
    const [isLoading, setIsLoading] = useState(false);
    const {fileEditing, onOpenChanged, setFileEditing} = props;
    const {filecategories} = useFilecategorys();
    const {
        createInsuranceBehaviour,
        editInsuranceBehaviour,
        editAddNewFiles,
        deleteInsuranceBehaviour
    } = useInsuranceBehaviourMutations();
    const initialObjectInintializer = useCallback(() => fileEditing ? {...fileEditing} : {...INSURANCE_BEHAVIOUR_EMPTY}, [])
    const initialFileObjectInitializer = useCallback(() => FILE_EMPTY, []);
    const {tempFileObject, onFileInputChange} = useForm(initialFileObjectInitializer);
    const {tempObject, onChange} = useForm(initialObjectInintializer)


    const {uploadFile} = useFileMutations();

    async function handleCreateSubmit(e) {
        e.preventDefault();
        const result = await createInsuranceBehaviour(tempObject);
        if (result && tempFileObject.file !== "") {
            const objReturn = await uploadFile(tempFileObject);
            if (objReturn) {
                await editAddNewFiles({...result, file: objReturn.id})
            }
        }
        onOpenChanged(false)
        setIsLoading(false);

    }

    async function handleEditSubmit(e) {
        e.preventDefault();
        const result = await editInsuranceBehaviour(tempObject);
        if (result) {
            if (tempFileObject.file !== "") {
                const objReturn = await uploadFile(tempFileObject);
                if (objReturn) {
                    await editAddNewFiles({...result, file: objReturn.id})
                }
            }
        }
        setIsLoading(false);
        setFileEditing(undefined);
        onOpenChanged(false)
    }

    console.log(tempObject)
    return <ModalContentContainer onOpenChanged={onOpenChanged} onEditingChanged={setFileEditing}>
        <Form onSubmit={(event) => {
            fileEditing ? handleEditSubmit(event) : handleCreateSubmit(event)
        }}>
            <Section title={fileEditing ? "Wijzig bestand" : "Nieuw bestand"}>
                <FormGroup>
                    <FormLabel>Titel</FormLabel>
                    <FormControl value={tempObject ? tempObject.title : ""}
                                 onChange={event => onChange(event, "title")}/>
                </FormGroup>
                {filecategories ? <FormGroup>
                        <FormLabel>Type bestand</FormLabel>
                        <FormSelect defaultValue={tempObject.type ? tempObject.type : "Selecteer type"}
                                    onChange={event => onChange(event, "type")}>
                            <option value={'Selecteer type'}>Selecteer type</option>
                            <option value={'behaviour'}>Gedragscode</option>
                            <option value={'insurance'}>Verzekering</option>
                        </FormSelect>
                        <FormGroup>
                            <FormLabel>Bestand</FormLabel>
                            <FormControl onChange={(e) => onFileInputChange(e, 'file')} type={"file"}/>
                        </FormGroup>
                    </FormGroup>
                    : ""}


                {fileEditing
                    ?
                    <Col xs={6}>
                        <Button onClick={async () => {
                            const message = await deleteInsuranceBehaviour(fileEditing);
                            if (message)
                                onOpenChanged(false);
                            setFileEditing(undefined);
                        }} className={"btn-danger mt-3"}>Delete</Button>
                    </Col>
                    :
                    ""
                }
                <Col xs={fileEditing ? 6 : 12} className={"text-end mt-3"}>
                    <ButtonLoading title={"Opslaan"} isLoading={isLoading} onClick={(e) => {
                        setIsLoading(true);
                        fileEditing ? handleEditSubmit(e) : handleCreateSubmit(e)
                    }}/>
                </Col>
            </Section>
        </Form>
    </ModalContentContainer>
}